import { useEffect, useState } from "react";
import { loadSuppliers } from "./constants";
import { comboboxOption } from "./constants";
export const useSuppliers = () => {
  const [supplierOptions, setSupplierOptions] = useState<comboboxOption[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await loadSuppliers();
      setSupplierOptions(data);
    };

    fetchData();
  }, []);

  return supplierOptions;
};